import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InsuranceService } from '../../../services/insurance.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { atLeastOneValidator } from '@gtd/helpers';
import { UnsubscribeService } from '@gtd/hotels/data-access/services';

import { markFormTouched } from '@gtd/utilities';
@Component({
  selector: 'gtd-pvi-dialog',
  templateUrl: './pvi-dialog.component.html',
  styleUrls: ['./pvi-dialog.component.scss'],
  providers: [UnsubscribeService]
})
export class PviDialogComponent implements OnInit, OnDestroy {
  customers$ = this.insuraceService.paxInfos$;
  insurers$ = this.insuraceService.insurers$;
  customerForm: FormGroup;
  isSubmitted: boolean;
  constructor(
    private insuraceService: InsuranceService,
    private dialogRef: MatDialogRef<PviDialogComponent>,
    private unsubscribeService: UnsubscribeService
  ) {
    this.customerForm = new FormGroup({
      customers: new FormArray([], [atLeastOneValidator('isHolder')])
    });
  }

  ngOnInit() {
    this.customers$
      .pipe(
        filter(customers => customers.length > 0),
        map(customers => {
          const validCustomers = customers.filter(
            customer => customer.age < 85
          );
          validCustomers.map(customer =>
            this.customerFormArray.push(
              new FormControl(this.parseCustomerForm(customer))
            )
          );
        }),
        takeUntil(this.unsubscribeService.unsubscribe$)
      )
      .subscribe();
  }

  parseCustomerForm(customer) {
    return {
      fullName: [customer.lastName, customer.firstName].join(' '),
      birthDay: customer.dob ? new Date(customer.dob) : null,
      identityDocument: customer.passport,
      gender:
        customer.sex === 'MALE'
          ? 'NAM'
          : customer.sex === 'FEMALE'
          ? 'NU'
          : null,
      type: customer.type
    };
  }

  onDeletePax(index: number) {
    this.customerFormArray.removeAt(index);
  }

  get customerFormArray() {
    return this.customerForm.get('customers') as FormArray;
  }

  onClose() {
    this.dialogRef.close({ action: 'none' });
  }

  onSubmit() {
    this.isSubmitted = true;
    markFormTouched(this.customerForm);
    if (this.customerForm.invalid) {
      return;
    }
    this.insuraceService.setInsurer(this.customerForm.value.customers);

    this.dialogRef.close({
      action: 'submit',
      data: this.customerForm.value
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeService.destroy();
  }
}
